import type { ParseKeys } from 'i18next';
import type { SparkSentiment } from '../../model/types';

/* eslint-disable i18next/no-literal-string -- design-system badge variant tokens, not labels */
export const SENTIMENT_BADGE_VARIANT = {
  Positive: 'positive',
  Negative: 'destructive',
  Neutral: 'warning',
} as const;
/* eslint-enable i18next/no-literal-string */

/**
 * `SparkSentiment` is the value the API sends and the key into
 * `SENTIMENT_BADGE_VARIANT`, so it stays English; the badge renders this label
 * instead of the value.
 */
export const SENTIMENT_LABEL_KEY: Record<SparkSentiment, ParseKeys<'audiences'>> = {
  Positive: 'personaSpark.sentiment.positive',
  Negative: 'personaSpark.sentiment.negative',
  Neutral: 'personaSpark.sentiment.neutral',
};
